import { Component, OnInit } from '@angular/core';
import { EventsManager } from "../../events/events.manager";
import { Router } from '@angular/router';
import { GroupCodeService } from '@wellfit-tech/wf-plans-services';

@Component({
  selector: 'app-ancillary-benefits-detail',
  templateUrl: './ancillary-benefits-detail.component.html',
  styleUrls: ['./ancillary-benefits-detail.component.scss']
})
export class AncillaryBenefitsDetailComponent implements OnInit {
  officeData: any = {};
  template: any = {};
  ancillaryCodes: string = '';

  constructor(
    public em: EventsManager, 
    private router: Router,
    private groupCodeService: GroupCodeService
  ) { }

  ngOnInit(): void {
    window.scrollTo(0, 0);
    this.officeData = this.em.officeInfo;
    
    // Get the template and ancillary codes
    const planDetailInfo = this.em.planDetailInfo;
    if (planDetailInfo && planDetailInfo.templateId) {
      this.template = this.em.officeInfo?.benefitPlanTemplates?.find((t: any) => 
        t.benefitPlanTemplateId == planDetailInfo.templateId
      );
      this.ancillaryCodes = this.template?.ancillaryBenefits || '';
    }
  }

  goBack(): void {
    this.router.navigate(['/plan-detail']);
  }

  navigateToSearch(): void {
    // Determine group code using the service
    const groupCode = this.groupCodeService.determineGroupCode(this.ancillaryCodes);
    
    // Build URL with query parameters
    const baseUrl = window.location.origin;
    const searchUrl = `${baseUrl}/ancillary-search?groupCode=${encodeURIComponent(groupCode)}`;
    
    // Open in new window
    window.open(searchUrl, '_blank');
  }
}
